import { SidebarWrapper, useIsMobile } from '@side/pantry';
import { SidebarContent } from './SidebarContent';

export function Sidebar() {
  const isMobile = useIsMobile('md');

  if (isMobile) {
    return null;
  }

  return (
    <SidebarWrapper sx={{ flexShrink: 0 }}>
      <SidebarContent />
    </SidebarWrapper>
  );
}
